/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react'
import Dropdown from './dropdown'
import { Item } from './types'

interface MultiselectProperties {
  selectedItems: Item[]
  setSelectedItems: React.Dispatch<React.SetStateAction<Item[]>>
  options: Item[]
}

const Multiselect = ({ selectedItems, setSelectedItems, options }: MultiselectProperties) => {
  const [dropdown, setDropdown] = useState(false)

  const toogleDropdown = () => {
    setDropdown(!dropdown)
  }

  const addTag = (item: Item) => {
    setSelectedItems(selectedItems.concat(item))
    setDropdown(false)
  }

  const removeTag = (item: Item) => {
    const filtered = selectedItems.filter((e) => e !== item)
    setSelectedItems(filtered)
  }

  const clickToggle = (event: MouseEvent) => {
    const multiselect = document.querySelector('#multiselect')
    if (!multiselect?.contains(event.target as Node)) {
      setDropdown(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', clickToggle)
    return () => {
      document.removeEventListener('click', clickToggle)
    }
  }, [])

  return (
    <div className="autcomplete-wrapper" id="multiselect">
      <div className="autcomplete">
        <div className="flex flex-col items-center w-full mx-auto">
          <div className="w-full">
            <div className="relative flex flex-col items-center">
              <div className="w-full">
                <div className="flex p-1 mb-4 bg-white border border-gray-200">
                  <div className="flex flex-wrap flex-auto">
                    {selectedItems.map((item: Item) => {
                      return (
                        <div
                          key={`selected-item-${item.value}`}
                          className="flex items-center justify-center px-2 py-1 m-1 font-medium bg-white border rounded-full text-primary border-primary-300"
                        >
                          <div className="flex-initial max-w-full text-xs font-normal leading-none">{item.label}</div>
                          <div className="flex flex-row-reverse flex-auto">
                            <div onClick={() => removeTag(item)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="100%"
                                height="100%"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-4 h-4 ml-2 rounded-full cursor-pointer feather feather-x hover:text-primary"
                              >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                    <div className="flex-1">
                      <input
                        placeholder={
                          selectedItems.length ? '' : 'Selecione os tipo(s) de produto(s) que seu negócio produz'
                        }
                        onClick={toogleDropdown}
                        className="w-full h-full p-1 px-2 text-gray-800 bg-transparent outline-none appearance-none"
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center w-8 py-1 pl-2 pr-1 text-gray-300 border-l border-gray-200"
                    onClick={toogleDropdown}
                  >
                    <button
                      className="w-6 h-6 text-gray-600 outline-none cursor-pointer focus:outline-none"
                      type="button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-4 h-4 feather feather-chevron-up"
                      >
                        <polyline points="18 15 12 9 6 15" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {dropdown ? <Dropdown list={options} addItem={addTag} /> : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Multiselect
